var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectDownarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22292 7.58231C6.63958 7.58231 6.05625 7.35731 5.61458 6.91564L0.18125 1.48231C-0.0604167 1.24064 -0.0604167 0.840641 0.18125 0.598975C0.422917 0.357308 0.822917 0.357308 1.06458 0.598975L6.49792 6.03231C6.89792 6.43231 7.54792 6.43231 7.94792 6.03231L13.3812 0.598975C13.6229 0.357308 14.0229 0.357308 14.2646 0.598975C14.5062 0.840641 14.5062 1.24064 14.2646 1.48231L8.83125 6.91564C8.38958 7.35731 7.80625 7.58231 7.22292 7.58231Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDownarrow);
export default __webpack_public_path__ + "static/media/select_downarrow.4f92119bd69a9cfe5a2a663df9495449.svg";
export { ForwardRef as ReactComponent };